import {type BindingIdAndPath} from '@packages/systems/ExpressionEditor-utils';
import {isCurrentPageNameBinding} from '@packages/systems/page-bindings';
import {
  type Identifier,
  type Qualified,
  namesEqual,
  qualify,
  pluginName,
  identifier,
} from '@packages/systems/wfdl-Qualified';

const listOfElementsTextIsSet = qualify(
  pluginName('ListOfElements'),
  identifier('TextIsSet')
);
const listOfElementsTextIsNotSet = qualify(
  pluginName('ListOfElements'),
  identifier('TextIsNotSet')
);

const isSetOrNotSetOperator = (operatorName: Qualified<Identifier>): boolean =>
  namesEqual(operatorName, listOfElementsTextIsSet) ||
  namesEqual(operatorName, listOfElementsTextIsNotSet);

/**
 * Restricts conditional operators for specific field bindings.
 * For `currentPage.name`, hide "is set" and "is not set" because
 * that field is guaranteed to be populated.
 */
export const isOperatorAllowedForConditionField = ({
  fieldBinding,
  operatorName,
}: {
  fieldBinding: BindingIdAndPath;
  operatorName: Qualified<Identifier>;
}): boolean => {
  if (isCurrentPageNameBinding(fieldBinding)) {
    return !isSetOrNotSetOperator(operatorName);
  }
  return true;
};
